import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import { WEEK_DAYS_SUN_START } from '@/constants/date';
import { getTimeStringFromTimestamps } from '@/helpers/time';

import type { FixedTime, NonFixedTime } from './types';

export const FIXED_SCHEDULE_TABLE_COLUMNS: ColumnsType<FixedTime> = [
  {
    title: '上課日',
    dataIndex: 'day',
  },
  {
    title: '課程時間',
    dataIndex: 'time',
    render: (_, record) => {
      if (!record.startTime || !record.endTime) {
        return null;
      }
      const timeString = getTimeStringFromTimestamps(
        record.startTime,
        record.endTime
      );
      return timeString;
    },
  },
  {
    title: '地點',
    dataIndex: 'place',
  },
  {
    title: '地址',
    dataIndex: 'address',
  },
];

export const NON_FIXED_SCHEDULE_TABLE_COLUMNS: ColumnsType<NonFixedTime> = [
  {
    title: '日期',
    dataIndex: 'date',
    render: (timestamp) =>
      dayjs(timestamp).format(
        `YYYY年MM月DD日(${WEEK_DAYS_SUN_START[dayjs(timestamp).day()]})`
      ),
    sorter: (a, b) => {
      if (!a.date) {
        return 1;
      }
      if (!b.date) {
        return -1;
      }
      return a.date - b.date;
    },
  },
  {
    title: '課程時間',
    dataIndex: 'time',
    render: (_, record) => {
      if (!record.startTime || !record.endTime) {
        return null;
      }
      const timeString = getTimeStringFromTimestamps(
        record.startTime,
        record.endTime
      );
      return timeString;
    },
  },
  {
    title: '地點',
    dataIndex: 'place',
  },
  {
    title: '地址',
    dataIndex: 'address',
  },
];
